var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"inner"},[_vm._m(0),_vm._m(1),_c('router-view')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"logo"}},[_c('img',{attrs:{"src":require("@/assets/teamsos-logo.png"),"alt":"teamSOS logo"}})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" This app generates an access token for the "),_c('b',[_vm._v("testing")]),_vm._v(" environment. ")])
}]

export { render, staticRenderFns }